import { mapGetters } from "vuex";
import { XMarkIcon } from "@heroicons/vue/24/outline";

export default {
	name: "InfoModal",
	components: {
		XMarkIcon,
	},
	props: ["toggleInfoModal", "isVisible"],
	computed: {
		...mapGetters("processes", ["currentCategory", "currentSector"]),
	},
	watch: {
		isVisible(newVal) {
			const event = new CustomEvent("modal-state-change", {
				detail: { isOpen: newVal },
			});
			document.dispatchEvent(event);
		},
	},
};